import { render } from "./LeftNavMenu.vue?vue&type=template&id=06365178&scoped=true"
import script from "./LeftNavMenu.vue?vue&type=script&lang=js"
export * from "./LeftNavMenu.vue?vue&type=script&lang=js"

import "./LeftNavMenu.vue?vue&type=style&index=0&id=06365178&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06365178"]])

export default __exports__